<template>
  <label
    class="text"
    v-bind:class="rootClasses"
  >
    <span class="text__label">{{ title }}</span>
    <input
      class="text__input"
      data-lpignore="true"
      type="text"
      v-bind:aria-invalid="hasViolations"
      v-bind:maxlength="maxLength"
      v-bind:value="value"
      v-on:input="onInput"
    />
    <div class="counter">{{ currentTextLength }}/{{ maxLength }}</div>
    <p
      class="text__violation"
      role="alert"
      v-for="violationText in violations"
      v-bind:key="violationText"
    >{{ violationText }}</p>
  </label>
</template>
<script>

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Компонент ввода однострочного текста.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Текущая длина текста
     * @return {number}
     */
    currentTextLength() {
      return this.value.length || 0;
    },
    /**
     * @description Имеет нарушения.
     * @type {boolean}
     */
    hasViolations() {
      return this.violations.length > 0;
    },
    /**
     * @description Список классов корневого элемента.
     * @type {string[]}
     */
    rootClasses() {
      const list = [];
      if (this.hasViolations) {
        list.push('invalid');
      }
      return list;
    },
  },
  methods: {
    /**
     * @description Обработать ввод.
     * @param {InputEvent} event Событие.
     * @returns {void}
     */
    onInput(event) {
      this.$emit(NAME_EVENT_INPUT, event.target.value);
    },
  },
  name: 'InputTextLengthLimitation',
  props: {
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: { default: '', type: String },
    /**
     * @description Значение.
     * @type {string}
     */
    value: { required: true, type: String },
    /**
     * @description Максимальная длина инпута
     * @type {Number}
     */
    maxLength: { type: Number, required: true },
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    violations: {
      default: () => [],
      type: Array,
    },
  },
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";
@use "@/scss/fields";
.text {
  display: flex;
  flex-direction: column;
  &__label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin: 0 0 2px 0;
    color: var(--unfocus-color);
  }
  &__input {
    @include fields.input-field();
  }
  &.invalid .text__input {
    color: var(--warning-color);
  }
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
}
.invalid {
  background: transparent !important;
}
.counter {
  display: flex;
  justify-content: flex-end;
  font-size: 0.7em;
}
</style>
